/* eslint-disable max-len */
import EaSasIcon1 from '@propertypal/shared/src/resources/icons/products/ea-competitors-icon.svg';
import EaSasIcon2 from '@propertypal/shared/src/resources/icons/products/ea-consultancy-icon.svg';
import EaSasIcon3 from '@propertypal/shared/src/resources/icons/products/ea-profile-icon.svg';
import Sas from '@propertypal/shared/src/resources/icons/products/ea-sponsor-search-icon.svg';
import SasMockup from '@propertypal/shared/src/resources/images/sponsor-a-search/ea-sas-mockup.png';
import platform from '@propertypal/shared/src/utils/platform';
import ProductsPageHeader, { ProcutsHeaderIcon } from '@propertypal/web-ui/src/headers/products/ProductsPageHeader';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import ProductScreenTabs, { ProductScreenTab } from '@propertypal/web-ui/src/products/ProductScreenTabs';
import SponsorSearchFeatures from '@propertypal/web-ui/src/products/SponsorSearchFeatures';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: `Estate Agents Sponsor a Search - ${platform.title}`,
  description: 'Showcase Your Brand And Key Message In Front Of Thousands Of Potential Buyers.',
  url: `/products/estate-agents/sponsor-a-search`,
};

const tabs: ProductScreenTab[] = [
  {
    title: 'Takeover a town',
    text: `Your brand and message takes over the full top section of the search results page in your chosen location.`,
    maxW: 420,
  },
  {
    title: 'Exclusive advertising power',
    text: `Display your message and brand in a permanent spot, in a prime location of your choice, for the duration of your campaign.`,
    maxW: 330,
  },
  {
    title: 'Maximise exposure',
    text: `Showcase your brand and key message in front of thousands of potential buyers.`,
    maxW: 320,
  },
];

const icons: ProcutsHeaderIcon[] = [
  {
    SVG: EaSasIcon1,
    heading: 'Gain the edge on your competitors',
    headingMaxW: 240,
    headingSize: 24,
    headingMt: 25,
    headingWeight: '600',
  },
  {
    SVG: EaSasIcon2,
    heading: 'Win new instructions and grow your business',
    headingMaxW: 310,
    headingSize: 24,
    headingMt: 25,
    headingWeight: '600',
  },
  {
    SVG: EaSasIcon3,
    heading: 'Raise the profile of your brand in key areas',
    headingMaxW: 300,
    headingSize: 24,
    headingMt: 25,
    headingWeight: '600',
  },
];

const EstateAgentSponsorASearch = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <ProductsPageHeader
        title="Sponsor a Search"
        text="Showcase your brand and key message in front of thousands of potential buyers"
        headingProps={{ mb: 10 }}
        subHeadingProps={{ maxWidth: 970, mb: 100 }}
        icon={<Sas />}
        icons={icons}
        iconsColumnGap={90}
      />
      <ProductScreenTabs
        tabs={tabs}
        aspectRatio="559 / 337"
        mockupWidth={700}
        negMargin={70}
        maxW={1200}
        breakpoint={1200}
        tabsMt={-15}
        reverse
        pb={20}
        button={{
          onClick: () => document.getElementById('contact-us')?.scrollIntoView({ behavior: 'smooth' }),
          text: 'Contact us',
          containerStyle: { maxWidth: '280px' },
        }}
        smallPrint="Note: Fully functional on mobile and desktop devices, location choices and advert design included."
        mockup={SasMockup}
        staticTabs
        buttonXPadding={20}
      />
      <SponsorSearchFeatures />
      <ProductsContact reason="Estate Agents Sponsor a Search" />
    </>
  );
};

export default EstateAgentSponsorASearch;
